export default "__VITE_ASSET__CEfbtfoY__"